import React, { useMemo } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Column, ColumnGroup } from '@cards/Card';
import PathwayStagesTableCard from '@pathways/cards/Pathways/PathwayStagesTable';
import EngagementChecksCard from '@pathways/cards/Pathways/EngagementChecks';
import IndexEventTriggeredRulesCard from '@pathways/cards/Pathways/IndexEventTriggeredRules';
import PathwayDetailsCard from '@pathways/cards/Pathways/PathwayDetails/Card';
import CareTeamPermissionsCard from '@pathways/cards/Pathways/CareTeamPermissions/Card';

export default ({ pathway, isSharedPathway }) => {
  const history = useHistory();
  const match = useRouteMatch();

  if (!pathway) {
    return null;
  }

  const roleRulesMap = useMemo(() => {
    return pathway.roles?.reduce((acc, role) => {
      role.permissions.forEach(permission => {
        const ruleId = permission.id || permission.rule?.id;
        if (!ruleId) {
          return;
        }

        if (!acc[ruleId]) {
          acc[ruleId] = [];
        }

        acc[ruleId].push({
          roleName: role.name,
          permissionType: permission.permissionType,
        });
      });
      return acc;
    }, {});
  }, [pathway]);

  return (
    <>
      <ColumnGroup>
        <Column>
          <PathwayStagesTableCard
            pathwayId={pathway.id}
            history={history}
            match={match}
            sharedPathway={isSharedPathway ? pathway : null}
            roleRulesMap={roleRulesMap}
          />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <IndexEventTriggeredRulesCard pathwayId={pathway.id} roleRulesMap={roleRulesMap} />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <CareTeamPermissionsCard pathway={pathway} />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <EngagementChecksCard
            pathwayId={pathway.id}
            disabled={pathway?.isReadOnly}
            isSharedPathway={isSharedPathway}
          />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <PathwayDetailsCard pathway={pathway} />
        </Column>
        <Column />
      </ColumnGroup>
    </>
  );
};
